module.exports = __webpack_public_path__ + "static/img/pic_aboutus_map.f472ec2c.jpg";